<template>
    <div class="login">
      <b-container>
        <h2 class="section-heading">Trailfinders Employer Reference Form</h2>
        <b-row>
          <b-col>
            <div class="login-card">
              <b-form v-if="!displayNoReference && !submissionSuccess">
                <!-- Name of Applicant -->
                <label class="input-label">Name of Applicant</label>
                <b-form-group
                >
                  <b-form-input
                  disabled
                    v-model="$v.form.applicantName.$model"
                  ></b-form-input>
                </b-form-group>
                <!-- Date joined -->
                <label class="input-label">Date Joined</label>
                <b-form-group
                >
                  <b-form-input
                  disabled
                    v-model="$v.form.startDate.$model"
                    type="date"
                  ></b-form-input>
                  </b-form-group>
                   <!-- Date left -->
                <label class="input-label">Date Left</label>
                <b-form-group
                >
                  <b-form-input v-if="form.endDate"
                  disabled
                    v-model="form.endDate"
                    type="date"
                  ></b-form-input>
                  <b-form-input v-else disabled value="Still employed"></b-form-input>
                </b-form-group>
                 <!-- Position -->
                 <label class="input-label">Position Held</label>
                <b-form-group
                >
                  <b-form-input
                  disabled
                    v-model="$v.form.position.$model"
                  ></b-form-input>
                </b-form-group>
                 <!-- Employment status -->
                 <label class="input-label">Employment Status</label>
                <b-form-group
                >
                  <b-form-input
                  disabled
                    v-model="$v.form.employmentStatus.$model"
                  ></b-form-input>
                </b-form-group>
                <!-- Disclaimer -->
                <b-form-group>
                <label>Is all of the above information correct?</label>
                <div class="radio radio-custom">
                    <input id="disclaimerYes"
                           name="disclaimer"
                           v-model="$v.form.disclaimer.$model"
                           type="radio"
                           value="Yes"
                    >
                    <label for="disclaimerYes">Yes</label>
                </div>
                <div class="radio radio-custom">
                    <input id="disclaimerNo"
                           name="disclaimer"
                           v-model="$v.form.disclaimer.$model"
                           type="radio"
                           value="No"
                    >
                    <label for="disclaimerNo">No</label>
                </div>
                <p class="error-text" v-if="$v.form.disclaimer.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
            <!-- Reason -->
            <b-form-group>
                <label>Reason for leaving</label>
                <div class="radio radio-custom">
                    <input id="reasonVoluntary"
                           name="reason"
                           v-model="$v.form.reason.$model"
                           type="radio"
                           value="Voluntary"
                    >
                    <label for="reasonVoluntary">Voluntary</label>
                </div>
                <div class="radio radio-custom">
                    <input id="reasonIssue"
                           name="reason"
                           v-model="$v.form.reason.$model"
                           type="radio"
                           value="Performance Issue"
                    >
                    <label for="reasonIssue">Performance Issue</label>
                </div>
                <div class="radio radio-custom">
                    <input id="reasonRedundancy"
                           name="reason"
                           v-model="$v.form.reason.$model"
                           type="radio"
                           value="Redundancy"
                    >
                    <label for="reasonRedundancy">Redundancy</label>
                </div>
                <div class="radio radio-custom">
                    <input id="reasonGeneral"
                           name="reason"
                           v-model="$v.form.reason.$model"
                           type="radio"
                           value="General Dismissal"
                    >
                    <label for="reasonGeneral">General Dismissal</label>
                </div>
                <p class="error-text" v-if="$v.form.reason.$error"><strong>Please select an option</strong></p>
            </b-form-group>
             <!-- Role -->
             <label class="input-label">Brief description of their duties</label>
                <b-form-group
                >
                  <b-form-textarea
                  :class="{
                    'is-valid': !$v.form.role.$error && form.role,
                    'is-invalid': $v.form.role.$error && $v.form.role.$dirty
                  }"
                    v-model="$v.form.role.$model"
                    rows="10"
                  ></b-form-textarea>
                </b-form-group>
                <!-- Effective -->
                <b-form-group>
                <label>Did they effectively perform their duties?</label>
                <div class="radio radio-custom">
                    <input id="effectiveYes"
                           name="effective"
                           v-model="$v.form.effective.$model"
                           type="radio"
                           value="Yes"
                    >
                    <label for="effectiveYes">Yes</label>
                </div>
                <div class="radio radio-custom">
                    <input id="effectiveNo"
                           name="effective"
                           v-model="$v.form.effective.$model"
                           type="radio"
                           value="No"
                    >
                    <label for="effectiveNo">No</label>
                </div>
                <p class="error-text" v-if="$v.form.effective.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
            <label>Please rate the canditate in the following areas</label>
            <!-- Overall -->
            <b-form-group>
                <label>Overall Assessment</label>
                <div class="radio radio-custom">
                    <input id="overallExcellent"
                           name="overall"
                           v-model="$v.form.overall.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="overallExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="overallGood"
                           name="overall"
                           v-model="$v.form.overall.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="overallGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="overallPoor"
                           name="overall"
                           v-model="$v.form.overall.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="overallPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="overallNA"
                           name="overall"
                           v-model="$v.form.overall.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="overallNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.overall.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Sales -->
             <b-form-group>
                <label>Sales Skills</label>
                <div class="radio radio-custom">
                    <input id="salesExcellent"
                           name="sales"
                           v-model="$v.form.sales.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="salesExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="salesGood"
                           name="sales"
                           v-model="$v.form.sales.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="salesGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="salesPoor"
                           name="sales"
                           v-model="$v.form.sales.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="salesPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="salesNA"
                           name="sales"
                           v-model="$v.form.sales.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="salesNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.sales.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Customer Service -->
             <b-form-group>
                <label>Customer Service Skills</label>
                <div class="radio radio-custom">
                    <input id="customerServiceExcellent"
                           name="customerService"
                           v-model="$v.form.customerService.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="customerServiceExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="customerServiceGood"
                           name="customerService"
                           v-model="$v.form.customerService.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="customerServiceGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="customerServicePoor"
                           name="customerService"
                           v-model="$v.form.customerService.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="customerServicePoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="customerServiceNA"
                           name="customerService"
                           v-model="$v.form.customerService.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="customerServiceNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.customerService.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Initiative -->
             <b-form-group>
                <label>Initiative</label>
                <div class="radio radio-custom">
                    <input id="initiativeExcellent"
                           name="initiative"
                           v-model="$v.form.initiative.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="initiativeExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="initiativeGood"
                           name="initiative"
                           v-model="$v.form.initiative.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="initiativeGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="initiativePoor"
                           name="initiative"
                           v-model="$v.form.initiative.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="initiativePoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="initiativeNA"
                           name="initiative"
                           v-model="$v.form.initiative.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="initiativeNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.initiative.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Reliability -->
             <b-form-group>
                <label>Reliability</label>
                <div class="radio radio-custom">
                    <input id="reliabilityExcellent"
                           name="reliability"
                           v-model="$v.form.reliability.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="reliabilityExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="reliablilityGood"
                           name="reliability"
                           v-model="$v.form.reliability.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="reliablilityGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="reliablilityPoor"
                           name="reliablility"
                           v-model="$v.form.reliability.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="reliablilityPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="reliablilityNA"
                           name="reliablility"
                           v-model="$v.form.reliability.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="reliabilityNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.reliability.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Punctuality -->
             <b-form-group>
                <label>Punctuality</label>
                <div class="radio radio-custom">
                    <input id="punctualityExcellent"
                           name="punctuality"
                           v-model="$v.form.punctuality.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="punctualityExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="punctualityGood"
                           name="punctuality"
                           v-model="$v.form.punctuality.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="punctualityGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="punctualityPoor"
                           name="punctuality"
                           v-model="$v.form.punctuality.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="punctualityPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="punctualityNA"
                           name="punctuality"
                           v-model="$v.form.punctuality.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="punctualityNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.punctuality.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Honesty and Integrity -->
             <b-form-group>
                <label>Honesty and Integrity</label>
                <div class="radio radio-custom">
                    <input id="honestyExcellent"
                           name="honesty"
                           v-model="$v.form.honesty.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="honestyExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="honestyGood"
                           name="honesty"
                           v-model="$v.form.honesty.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="honestyGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="honestyPoor"
                           name="honesty"
                           v-model="$v.form.honesty.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="honestyPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="honestyNA"
                           name="honesty"
                           v-model="$v.form.honesty.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="honestyNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.honesty.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Quality of work -->
             <b-form-group>
                <label>Quality of Work</label>
                <div class="radio radio-custom">
                    <input id="qualityExcellent"
                           name="quality"
                           v-model="$v.form.quality.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="qualityExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="qualityGood"
                           name="quality"
                           v-model="$v.form.quality.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="qualityGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="qualityPoor"
                           name="quality"
                           v-model="$v.form.quality.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="qualityPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="qualityNA"
                           name="quality"
                           v-model="$v.form.quality.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="qualityNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.quality.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Relationship with colleagues -->
             <b-form-group>
                <label>Relationship with Colleagues</label>
                <div class="radio radio-custom">
                    <input id="colleagueRelationshipExcellent"
                           name="colleagueRelationship"
                           v-model="$v.form.colleagueRelationship.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="colleagueRelationshipExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="colleagueRelationshipGood"
                           name="colleagueRelationship"
                           v-model="$v.form.colleagueRelationship.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="colleagueRelationshipGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="colleagueRelationshipPoor"
                           name="colleagueRelationship"
                           v-model="$v.form.colleagueRelationship.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="colleagueRelationshipPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="colleagueRelationshipNA"
                           name="colleagueRelationship"
                           v-model="$v.form.colleagueRelationship.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="colleagueRelationshipNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.colleagueRelationship.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Relationship with management -->
             <b-form-group>
                <label>Relationship with Supervisors/Managers</label>
                <div class="radio radio-custom">
                    <input id="managementRelationshipExcellent"
                           name="managementRelationship"
                           v-model="$v.form.managementRelationship.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="managementRelationshipExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="managementRelationshipGood"
                           name="managementRelationship"
                           v-model="$v.form.managementRelationship.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="managementRelationshipGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="managementRelationshipPoor"
                           name="managementRelationship"
                           v-model="$v.form.managementRelationship.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="managementRelationshipPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="managementRelationshipNA"
                           name="managementRelationship"
                           v-model="$v.form.managementRelationship.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="managementRelationshipNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.managementRelationship.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Computer competencey -->
             <b-form-group>
                <label>Computer Competency</label>
                <div class="radio radio-custom">
                    <input id="computerCompetencyExcellent"
                           name="computerCompetency"
                           v-model="$v.form.computerCompetency.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="computerCompetencyExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="computerCompetencyGood"
                           name="computerCompetency"
                           v-model="$v.form.computerCompetency.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="computerCompetencyGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="computerCompetencyPoor"
                           name="computerCompetency"
                           v-model="$v.form.computerCompetency.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="computerCompetencyPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="computerCompetencyNA"
                           name="computerCompetency"
                           v-model="$v.form.computerCompetency.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="computerCompetencyNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.computerCompetency.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- New Skills -->
             <b-form-group>
                <label>Willing to learn new skills and push out of their comfort zone</label>
                <div class="radio radio-custom">
                    <input id="newSkillsExcellent"
                           name="newSkills"
                           v-model="$v.form.newSkills.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="newSkillsExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="newSkillsGood"
                           name="newSkills"
                           v-model="$v.form.newSkills.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="newSkillsGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="newSkillsPoor"
                           name="newSkills"
                           v-model="$v.form.newSkills.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="newSkillsPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="newSkillsNA"
                           name="newSkills"
                           v-model="$v.form.newSkills.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="newSkillsNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.newSkills.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- New systems -->
             <b-form-group>
                <label>Ability to grasp new systems/procedures</label>
                <div class="radio radio-custom">
                    <input id="newSystemProficiencyExcellent"
                           name="newSystemProficiency"
                           v-model="$v.form.newSystemProficiency.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="newSystemProficiencyExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="newSystemProficiencyGood"
                           name="newSystemProficiency"
                           v-model="$v.form.newSystemProficiency.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="newSystemProficiencyGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="newSystemProficiencyPoor"
                           name="newSystemProficiency"
                           v-model="$v.form.newSystemProficiency.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="newSystemProficiencyPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="newSystemProficiencyNA"
                           name="newSystemProficiency"
                           v-model="$v.form.newSystemProficiency.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="newSystemProficiencyNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.newSystemProficiency.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Appearance -->
             <b-form-group>
                <label>Appearance</label>
                <div class="radio radio-custom">
                    <input id="appearanceExcellent"
                           name="appearance"
                           v-model="$v.form.appearance.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="appearanceExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="appearanceGood"
                           name="appearance"
                           v-model="$v.form.appearance.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="appearanceGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="appearancePoor"
                           name="appearance"
                           v-model="$v.form.appearance.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="appearancePoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="appearanceNA"
                           name="appearance"
                           v-model="$v.form.appearance.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="appearanceNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.appearance.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- General Conduct -->
             <b-form-group>
                <label>General Conduct</label>
                <div class="radio radio-custom">
                    <input id="conductExcellent"
                           name="conduct"
                           v-model="$v.form.conduct.$model"
                           type="radio"
                           value="Excellent"
                    >
                    <label for="conductExcellent">Excellent</label>
                </div>
                <div class="radio radio-custom">
                    <input id="conductGood"
                           name="conduct"
                           v-model="$v.form.conduct.$model"
                           type="radio"
                           value="Good"
                    >
                    <label for="conductGood">Good</label>
                </div>
                <div class="radio radio-custom">
                    <input id="conductPoor"
                           name="conduct"
                           v-model="$v.form.conduct.$model"
                           type="radio"
                           value="Poor"
                    >
                    <label for="conductPoor">Poor</label>
                </div>
                <div class="radio radio-custom">
                    <input id="conductNA"
                           name="conduct"
                           v-model="$v.form.conduct.$model"
                           type="radio"
                           value="N/A"
                    >
                    <label for="conductNA">N/A</label>
                </div>
                <p class="error-text" v-if="$v.form.conduct.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
            <!-- Work to targets -->
            <b-form-group>
                <label>Did the role involve working to targets?</label>
                <div class="radio radio-custom">
                    <input id="workingToTargetsYes"
                           name="workingToTargets"
                           v-model="$v.form.workingToTargets.$model"
                           type="radio"
                           value="Yes"
                    >
                    <label for="workingToTargetsYes">Yes</label>
                </div>
                <div class="radio radio-custom">
                    <input id="workingToTargetsNo"
                           name="workingToTargets"
                           v-model="$v.form.workingToTargets.$model"
                           type="radio"
                           value="No"
                    >
                    <label for="workingToTargetsNo">No</label>
                </div>
                <p class="error-text" v-if="$v.form.workingToTargets.$error"><strong>Please select an option</strong></p>
            </b-form-group>
             <!-- React to Challenges -->
             <label class="input-label">How does the candidate react to being challenged on performance, conduct or areas of improvement?</label>
                <b-form-group
                >
                  <b-form-input
                  :class="{
                    'is-valid': !$v.form.reaction.$error && form.reaction,
                    'is-invalid': $v.form.reaction.$error && $v.form.reaction.$dirty
                  }"
                    v-model="$v.form.reaction.$model"
                  ></b-form-input>
                </b-form-group>
                 <!-- Pro Re active -->
                 <label class="input-label">Would you consider them pro-active or re-active?</label>
                <b-form-group
                >
                  <b-form-input
                  :class="{
                    'is-valid': !$v.form.proReActive.$error && form.proReActive,
                    'is-invalid': $v.form.proReActive.$error && $v.form.proReActive.$dirty
                  }"
                    v-model="$v.form.proReActive.$model"
                  ></b-form-input>
                </b-form-group>
                <hr />
                 <!-- Sick days -->
                 <label class="input-label">Number of days sick in last 12 months</label>
                <b-form-group
                >
                  <b-form-input
                  :class="{
                    'is-valid': !$v.form.sickDays.$error && form.sickDays,
                    'is-invalid': $v.form.sickDays.$error && $v.form.sickDays.$dirty
                  }"
                    v-model="$v.form.sickDays.$model"
                  ></b-form-input>
                </b-form-group>
                <!-- Reemploy -->
            <b-form-group>
                <label>Would you re-employ?</label>
                <div class="radio radio-custom">
                    <input id="reEmployYes"
                           name="reEmploy"
                           v-model="$v.form.reEmploy.$model"
                           type="radio"
                           value="Yes"
                    >
                    <label for="reEmployYes">Yes</label>
                </div>
                <div class="radio radio-custom">
                    <input id="reEmployNo"
                           name="reEmploy"
                           v-model="$v.form.reEmploy.$model"
                           type="radio"
                           value="No"
                    >
                    <label for="reEmployNo">No</label>
                </div>
                <p class="error-text" v-if="$v.form.reEmploy.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <!-- Disiplinary -->
            <b-form-group>
                <label>Is the applicant currently subject to any disciplinary action?</label>
                <div class="radio radio-custom">
                    <input id="disciplinaryYes"
                           name="disciplinary"
                           v-model="$v.form.disciplinary.$model"
                           type="radio"
                           value="Yes"
                    >
                    <label for="disciplinaryYes">Yes</label>
                </div>
                <div class="radio radio-custom">
                    <input id="disciplinaryNo"
                           name="disciplinary"
                           v-model="$v.form.disciplinary.$model"
                           type="radio"
                           value="No"
                    >
                    <label for="disciplinaryNo">No</label>
                </div>
                <p class="error-text" v-if="$v.form.disciplinary.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <!-- Parental leave -->
            <b-form-group>
                <label>Has the applicant taken any parental leave whilst at your company?</label>
                <div class="radio radio-custom">
                    <input id="parentalLeaveYes"
                           name="parentalLeave"
                           v-model="$v.form.parentalLeave.$model"
                           type="radio"
                           value="Yes"
                    >
                    <label for="parentalLeaveYes">Yes</label>
                </div>
                <div class="radio radio-custom">
                    <input id="parentalLeaveNo"
                           name="parentalLeave"
                           v-model="$v.form.parentalLeave.$model"
                           type="radio"
                           value="No"
                    >
                    <label for="parentalLeaveNo">No</label>
                </div>
                <p class="error-text" v-if="$v.form.parentalLeave.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
             <!-- Comments -->
             <label class="input-label">Any additional comments</label>
                <b-form-group
                >
                  <b-form-textarea
                  rows="10"
                    v-model="form.comments"
                  ></b-form-textarea>
                </b-form-group>
            <!-- Applicant Request -->
            <b-form-group>
                <label>If requested do you agree to this reference being shown to {{ form.applicantName }}</label>
                <div class="radio radio-custom">
                    <input id="showToApplicantYes"
                           name="workingToTargets"
                           v-model="$v.form.showToApplicant.$model"
                           type="radio"
                           value="Yes"
                    >
                    <label for="showToApplicantYes">Yes</label>
                </div>
                <div class="radio radio-custom">
                    <input id="showToApplicantNo"
                           name="showToApplicant"
                           v-model="$v.form.showToApplicant.$model"
                           type="radio"
                           value="No"
                    >
                    <label for="showToApplicantNo">No</label>
                </div>
                <p class="error-text" v-if="$v.form.showToApplicant.$error"><strong>Please select an option</strong></p>
            </b-form-group>
            <hr />
                <b-form-group>
                  <BtnMain
                  @btnClicked="handleSubmit"
                  text="Submit Reference"
                  btnClass="login-btn mt-4"
                  variant="success" 
                />
                </b-form-group>
                <b-form-group>
                  <b-alert v-if="error"
                    show 
                    variant="danger"
                  >
                    <p>{{ errorMsg }}</p>
                  </b-alert>
                </b-form-group>
              </b-form>
              <div v-if="displayNoReference">
                <p>There is no reference currently available. Please try again at a later time or contact our personnel department.</p>
              </div>
              <div v-if="submissionSuccess">
                <p>Thank you for submitting your reference for {{ form.applicantName }}. We will contact you if we have any further questions.</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  
  <script>
  import BtnMain from '../components/BtnMain'
  import { required } from 'vuelidate/lib/validators'
  import { getReferenceDetails, submitReference } from '@/services/api'
  
  export default {
    components: {
      BtnMain
    },
    data () {
      return {
        form: {
          applicantName: '',
          startDate: '',
          endDate: '',
          position: '',
          employmentStatus:'',
          disclaimer: '',
          reason: '',
          role: '',
          effective: '',
          overall: '',
          sales: '',
          customerService: '',
          initiative: '',
          reliability: '',
          punctuality: '',
          honesty: '',
          quality: '',
          colleagueRelationship: '',
          managementRelationship: '',
          computerCompetency: '',
          newSkills: '',
          newSystemProficiency: '',
          appearance: '',
          conduct: '',
          workingToTargets: '',
          reaction: '',
          proReActive: '',
          sickDays: '',
          reEmploy: '',
          disciplinary: '',
          parentalLeave: '',
          comments: '',
          showToApplicant: ''
        },
        displayNoReference: false,
        error: false,
        errorMsg: '',
        submissionSuccess: false
      }
    },
    mounted () {
      this.fetchApplicantReferenceDetails()
    },
    methods: {
      async fetchApplicantReferenceDetails () {
        const res = await getReferenceDetails(this.$route.params.id)
        if (res && res.data && res.data.success) {
          this.displayNoReference = false
          this.form.applicantName = res.data.referenceDetails.applicantName
          this.form.startDate = res.data.referenceDetails.startDate
          this.form.endDate = res.data.referenceDetails.endDate
          this.form.position = res.data.referenceDetails.position
          this.form.employmentStatus = res.data.referenceDetails.employmentStatus
        } else {
          this.displayNoReference = true
        }
      },
      async handleSubmit () {
        // Check fields are valid before submission attempt
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.error = false
          const res = await submitReference(this.$route.params.id, this.form)
          if (!res) {  
            this.error = true
            this.errorMsg = 'There was an error submitting your reference, please try again'
            setTimeout(() => {
              this.error = false
              this.errorMsg = ''
            }, 5000)
          } else {
            this.error = false
            this.errorMsg = ''
            this.submissionSuccess = true
          }
        } else {
          this.error = true
          this.errorMsg = 'Error submitting reference, please try again'
          setTimeout(() => {
              this.error = false
              this.errorMsg = ''
          }, 5000)
        }
      },
    },
    validations: {
      form: {
        applicantName: {
          required: required,
        },
        startDate: {
          required: required
        },
        position: {
          required: required
        },
        employmentStatus: {
          required: required
        },
        disclaimer: {
          required: required
        },
        reason: {
          required: required
        },
        role: {
          required: required
        },
        effective: {
          required: required
        },
        overall: {
          required: required
        },
          sales: {
            required: required
          },
          customerService: {
            required: required
          },
          initiative: {
            required: required
          },
          reliability: {
            required: required
          },
          punctuality: {
            required: required
          },
          honesty: {
            required: required
          },
          quality: {
            required: required
          },
          colleagueRelationship: {
            required: required
          },
          managementRelationship: {
            required: required
          },
          computerCompetency: {
            required: required
          },
          newSkills: {
            required: required
          },
          newSystemProficiency: {
            required: required
          },
          appearance: {
            required: required
          },
          conduct: {
            required: required
          },
          workingToTargets: {
            required: required
          },
          reaction: {
            required: required
          },
          proReActive: {
            required: required
          },
          sickDays: {
            required: required
          },
          reEmploy: {
            required: required
          },
          disciplinary: {
            required: required
          },
          parentalLeave: {
            required: required
          },
          showToApplicant: {
            required: required
          }
      }
    }
  }
  </script>
  
  <style scoped>
  .input-label{
    font-weight: 500;
  }
  .password-input{
    border-right: none;
  }
  .password-icon-wrapper > *{
    background-color: white;
  }
  .password-icon-wrapper > *:hover{
    color: green;
    cursor: pointer;
  }
  .error-text {
    color: red;
  }
  </style>